import loglevel from 'loglevel';

import { LOG_LEVEL } from '@/config';

const log = loglevel.getLogger('legal-docs');

const level = log.levels[LOG_LEVEL] || log.levels.SILENT;

log.setDefaultLevel(level);

export default log;
